// Generated by purs version 0.13.0
"use strict";
var Chip_Model_DieReason = require("../Chip.Model.DieReason/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Show = require("../Data.Show/index.js");
var DoorOpen = (function () {
    function DoorOpen() {

    };
    DoorOpen.value = new DoorOpen();
    return DoorOpen;
})();
var Oof = (function () {
    function Oof() {

    };
    Oof.value = new Oof();
    return Oof;
})();
var PickUpItem = (function () {
    function PickUpItem() {

    };
    PickUpItem.value = new PickUpItem();
    return PickUpItem;
})();
var Bummer = (function () {
    function Bummer() {

    };
    Bummer.value = new Bummer();
    return Bummer;
})();
var PickUpChip = (function () {
    function PickUpChip() {

    };
    PickUpChip.value = new PickUpChip();
    return PickUpChip;
})();
var LevelComplete = (function () {
    function LevelComplete() {

    };
    LevelComplete.value = new LevelComplete();
    return LevelComplete;
})();
var Steal = (function () {
    function Steal() {

    };
    Steal.value = new Steal();
    return Steal;
})();
var Teleported = (function () {
    function Teleported() {

    };
    Teleported.value = new Teleported();
    return Teleported;
})();
var Splash = (function () {
    function Splash() {

    };
    Splash.value = new Splash();
    return Splash;
})();
var Complete = (function () {
    function Complete() {

    };
    Complete.value = new Complete();
    return Complete;
})();
var Die = (function () {
    function Die(value0) {
        this.value0 = value0;
    };
    Die.create = function (value0) {
        return new Die(value0);
    };
    return Die;
})();
var PlaySound = (function () {
    function PlaySound(value0) {
        this.value0 = value0;
    };
    PlaySound.create = function (value0) {
        return new PlaySound(value0);
    };
    return PlaySound;
})();
var withAction = function (result) {
    return function (action) {
        return {
            result: result,
            actions: [ action ]
        };
    };
};
var showSound = new Data_Show.Show(function (v) {
    if (v instanceof DoorOpen) {
        return "DoorOpen";
    };
    if (v instanceof Oof) {
        return "Oof";
    };
    if (v instanceof PickUpItem) {
        return "PickUpItem";
    };
    if (v instanceof Bummer) {
        return "Bummer";
    };
    if (v instanceof PickUpChip) {
        return "PickUpChip";
    };
    if (v instanceof LevelComplete) {
        return "LevelComplete";
    };
    if (v instanceof Steal) {
        return "Steal";
    };
    if (v instanceof Teleported) {
        return "Teleported";
    };
    if (v instanceof Splash) {
        return "Splash";
    };
    throw new Error("Failed pattern match at Chip.Action (line 30, column 10 - line 39, column 23): " + [ v.constructor.name ]);
});
var showAction = new Data_Show.Show(function (v) {
    if (v instanceof Complete) {
        return "Complete";
    };
    if (v instanceof Die) {
        return "Die " + Data_Show.show(Chip_Model_DieReason.showDieReason)(v.value0);
    };
    if (v instanceof PlaySound) {
        return "PlaySound" + Data_Show.show(showSound)(v.value0);
    };
    throw new Error("Failed pattern match at Chip.Action (line 49, column 10 - line 52, column 49): " + [ v.constructor.name ]);
});
var inactive = function (result) {
    return {
        result: result,
        actions: [  ]
    };
};
var eqSound = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof DoorOpen && y instanceof DoorOpen) {
            return true;
        };
        if (x instanceof Oof && y instanceof Oof) {
            return true;
        };
        if (x instanceof PickUpItem && y instanceof PickUpItem) {
            return true;
        };
        if (x instanceof Bummer && y instanceof Bummer) {
            return true;
        };
        if (x instanceof PickUpChip && y instanceof PickUpChip) {
            return true;
        };
        if (x instanceof LevelComplete && y instanceof LevelComplete) {
            return true;
        };
        if (x instanceof Steal && y instanceof Steal) {
            return true;
        };
        if (x instanceof Teleported && y instanceof Teleported) {
            return true;
        };
        if (x instanceof Splash && y instanceof Splash) {
            return true;
        };
        return false;
    };
});
var eqAction = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Complete && y instanceof Complete) {
            return true;
        };
        if (x instanceof Die && y instanceof Die) {
            return Data_Eq.eq(Chip_Model_DieReason.eqDieReason)(x.value0)(y.value0);
        };
        if (x instanceof PlaySound && y instanceof PlaySound) {
            return Data_Eq.eq(eqSound)(x.value0)(y.value0);
        };
        return false;
    };
});
var addAction = function (action) {
    return function (v) {
        return {
            result: v.result,
            actions: Data_Array.cons(action)(v.actions)
        };
    };
};
module.exports = {
    Complete: Complete,
    Die: Die,
    PlaySound: PlaySound,
    DoorOpen: DoorOpen,
    Oof: Oof,
    PickUpItem: PickUpItem,
    Bummer: Bummer,
    PickUpChip: PickUpChip,
    LevelComplete: LevelComplete,
    Steal: Steal,
    Teleported: Teleported,
    Splash: Splash,
    addAction: addAction,
    inactive: inactive,
    withAction: withAction,
    eqSound: eqSound,
    showSound: showSound,
    eqAction: eqAction,
    showAction: showAction
};
